<app-interest-selector *ngIf="chips.length > 0" (remove)="handleRemoveFilter($event)" mode="filter"
                       [interests]="chips"></app-interest-selector>
